var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-svg"},[_c('svg',{staticClass:"icon-svg__svg",style:(_vm.inlineStyles)},[_c('use',{staticClass:"icon-svg__use",attrs:{"xlink:href":_vm.iconPath}})])])}
var staticRenderFns = []

export { render, staticRenderFns }